import { useId } from 'react';
import { Box, Typography, Link } from '@mui/joy';
import { POLICY_URL, CONSENT_URL } from '../../legal';

export default function ConsentCheckbox({ checked, onChange, disabled = false }) {
  const id = useId();
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: '20px minmax(0, 1fr)', gap: 1,
      alignItems: 'start', bgcolor: 'transparent', boxShadow: 'none', p: 0 }}>
      <input id={id} type="checkbox" checked={checked === true} disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
        style={{ width: 18, height: 18, margin: '3px 0 0', accentColor: '#403D84',
          cursor: disabled ? 'not-allowed' : 'pointer' }} />
      <Typography component="label" htmlFor={id} level="body-xs"
        sx={{ lineHeight: 1.55, color: 'text.secondary', bgcolor: 'transparent',
          cursor: disabled ? 'default' : 'pointer', opacity: disabled ? 0.7 : 1 }}>
        Я даю <Link href={CONSENT_URL} target="_blank" rel="noopener noreferrer"
          onClick={(event) => event.stopPropagation()}>согласие на обработку персональных данных</Link>{' '}
        и подтверждаю, что ознакомлен(а) с{' '}
        <Link href={POLICY_URL} target="_blank" rel="noopener noreferrer"
          onClick={(event) => event.stopPropagation()}>политикой обработки персональных данных</Link>.
      </Typography>
    </Box>
  );
}